import React, { useState , Fragment, useEffect} from "react";
import Loading from "../assetLibComponents/Loading";
import { useDispatch, useSelector } from "react-redux";
import { StarFill } from "react-bootstrap-icons/dist";
import TabCalender from "../TabCalender";
import { createEventData, deleteEventData, fetchEventListing, fetchScheduleListing } from '../../redux/actions/settingActions';
import { Dialog, Listbox, Transition } from '@headlessui/react'
import { CheckIcon, CalendarDaysIcon } from '@heroicons/react/20/solid'
import { Cog8ToothIcon, PencilSquareIcon, StarIcon, TrashIcon } from "@heroicons/react/24/outline";
import "../chatAiComponents/ChatAii.css";
import { Switch } from '@headlessui/react'
import Toast from "../assetLibComponents/shared/Toast";
import { useNavigate } from "react-router-dom";

const publishing_event_options = [
  { title: 'Edit', current: true, icon: PencilSquareIcon },
  { title: 'Set as default', current: false, icon: StarIcon },
  { title: 'Setting', current: false, icon: Cog8ToothIcon },
  { title: 'Delete', current: false, icon: TrashIcon },
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const SettingCalender = (props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const isLoading = useSelector((state) => state.chatAi.loading);
    const [tabName, setTabName] = useState("Schedules");
    const tabs = [
        { name: "Connect", href: "/Setting/connect", current: false },
        { name: "Schedules", href: "/Setting/calender", current: false },
        { name: "Events", href: "/Setting/events", current: true },
    ];
    
    const authToken = props.authToken;
    const fetch_event_list = useSelector((state) => state.setting.fetchEventList);
    const [selectedGear, setSelectedGear] = useState({});
    const [enabled, setEnabled] = useState(false)
    const [eventId, setEventId] = useState(null);
    const [mode, setMode] = useState("");
    const [eventName, setEventName] = useState("");
    const [eventDescription, setEventDescription] = useState("");
    const [openEvent, setOpenEvent] = useState(false)
    
    useEffect(() => {
        dispatch(fetchEventListing(authToken));
        dispatch(fetchScheduleListing(authToken));
    }, [])
    
    
    const handleSettingEventFunction = (e, event_data) => {
        if (e.title === "Edit") {
            setOpenEvent(true);
            setEventName(event_data?.event_name);
            setEventDescription(event_data?.event_description);
            setEventId(event_data?.id);
            setEnabled(event_data.status === "1" ? true : false);
            setMode("edit");
        } else if (e.title === "Delete") {
            dispatch(deleteEventData(authToken, event_data?.id));
        } else if (e.title === "Setting") {
            navigate(`/Setting/eventSetting/${event_data?.id}`);
        } else if (e.title === "Set as default") {
            dispatch(createEventData(authToken, event_data?.event_name, event_data?.event_description, "1", event_data?.id))
        } else {
            return
        }
    }
    
    const handleCreateEvent = () => {
        if (mode === "new") {
            dispatch(createEventData(authToken, eventName, eventDescription, enabled === true ? "1" : "0"))
        } else {
            dispatch(createEventData(authToken, eventName, eventDescription, enabled === true ? "1" : "0", eventId))
        }
        setOpenEvent(false);
        setEventName("");
        setEventDescription("");
        setEnabled(false)
    }
    
    return (
        <>
        {isLoading && <Loading />}
            {/* Tabs */}
            <div className="px-6 sm:px-8 mb-4 lg:px-10">
                <TabCalender tabs={tabs} setTabName={setTabName} tabName={tabName} />  
            </div>
        
            <div className="h-[78vh] overflow-y-auto listing pt-1">
                <div className="px-6 sm:px-8 lg:px-10">
                    <div className="flex items-center justify-between mb-4">
                        <h3 className="text-lg font-semibold text-gray-600">Calendar Events</h3>
                        <button
                            type="button"
                            className="inline-flex mr-2 text-[white] px-4 items-center rounded-md p-1 hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] bg-[var(--brand-primary)] focus:outline-none focus:ring-2 focus:ring-[var(--brand-primary)] focus:ring-offset-2 focus:ring-offset-gray-50"
                            onClick={() => {
                                setOpenEvent(true);
                                setMode("new");
                            }}
                        >
                            + Add Event
                        </button>
                    </div>
                    <div className="flex flex-wrap">
                    {fetch_event_list?.map((event, e_index) => {
                        return (
                            <div key={e_index} className="bg-white shadow sm:rounded-lg w-[32%] max-sm:w-full mr-4 mb-2 max-sm:mr-0">
                                <div className="px-4 py-5 sm:p-6">
                                    <div className="flex items-center justify-between">
                                        <h3 className="text-base flex font-semibold leading-6 text-gray-900">{event.event_name}
                                            {event.status === "1" && <StarFill
                                                className={"h-5 w-5 ml-2 text-[var(--brand-primary)]"}
                                                aria-hidden="true"
                                            />}
                                        </h3>
                                            <div className="flex items-center">
                                                {/* <button
                                                    type="button"
                                                    className="inline-flex mr-2 items-center rounded-md bg-transparent p-1 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-[var(--brand-primary)] focus:ring-offset-2 focus:ring-offset-gray-50"
                                                >
                                                    <ShareIcon className="h-5 w-5 text-[gray]" aria-hidden="true" />
                                                </button> */}
                                                
                                                <Listbox value={selectedGear} onChange={(e) => { handleSettingEventFunction(e, event) }}>
                                                    {({ open }) => (
                                                        <>
                                                        <div className="relative">
                                                            <div className="inline-flex divide-x divide-indigo-700 shadow-sm">
                                                                <Listbox.Button className="inline-flex items-center rounded-md bg-transparent p-1 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-[var(--brand-primary)] focus:ring-offset-2 focus:ring-offset-gray-50">
                                                                    <Cog8ToothIcon className="h-6 w-6 text-[gray]" aria-hidden="true" />
                                                                </Listbox.Button>
                                                            </div>
                                                            <Transition
                                                                show={open}
                                                                as={Fragment}
                                                                leave="transition ease-in duration-100"
                                                                leaveFrom="opacity-100"
                                                                leaveTo="opacity-0"
                                                            >
                                                            <Listbox.Options className="absolute right-0 z-10 mt-2 w-40 origin-top-right divide-y divide-gray-200 overflow-hidden rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                                                {publishing_event_options?.map((option) => (
                                                                    <>
                                                                        {event.status === "1" && (option.title === "Delete" || option.title === "Set as default") ? 
                                                                            ""
                                                                            : 
                                                                            <Listbox.Option
                                                                                key={option.title}
                                                                                className={({ active }) =>
                                                                                classNames(
                                                                                    active ? 'bg-[var(--brand-primary)] text-white' : 'text-gray-900',
                                                                                    'cursor-default select-none p-2 text-sm'
                                                                                )
                                                                                }
                                                                                value={option}
                                                                            >
                                                                                {({ selectedGear, active }) => (
                                                                                <div className="flex flex-col">
                                                                                    <div className="flex items-center">
                                                                                        <option.icon
                                                                                            className='h-4 w-4 shrink-0 mr-2'
                                                                                            aria-hidden="true"
                                                                                        />
                                                                                        <p className={selectedGear ? 'font-semibold' : 'font-normal'}>{option.title}</p>
                                                                                        {selectedGear ? (
                                                                                            <span className={active ? 'text-white' : 'text-[var(--brand-primary)]'}>
                                                                                            <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                                                                            </span>
                                                                                        ) : null}
                                                                                    </div>
                                                                                </div>
                                                                                )}
                                                                            </Listbox.Option>
                                                                        }
                                                                    </>
                                                                ))}
                                                            </Listbox.Options>
                                                            </Transition>
                                                        </div>
                                                        </>
                                                    )}
                                                </Listbox>
                                            </div>
                                        </div>
                                        
                                        <div className="mt-5">
                                        <div className="rounded-md bg-gray-50 px-6 py-5 sm:flex sm:items-start sm:justify-between">
                                            <div className="sm:flex items-center">
                                            <div><CalendarDaysIcon className="h-6 w-6 text-[gray]"/></div>
                                            <div className="mt-3 sm:ml-4 sm:mt-0">
                                                <div className="text-sm font-medium text-gray-900">{event?.event_description}</div>
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );                            
                    })}
                    </div>
                    {/* <SettingEvents authToken={props.authToken} pageName={props.pageName} subPageName={props.subPageName}/> */}
                </div>
            </div>
            
            <Transition.Root show={openEvent} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={setOpenEvent}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                        <Dialog.Panel className="relative max-sm:w-full transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
                            <div>
                                <div className="text-left">
                                    <Dialog.Title as="h3" className="text-lg font-semibold leading-6 text-gray-900">
                                        {mode === "new" ? "Add":"Update"} Event
                                    </Dialog.Title>
                                    <div>
                                        <label htmlFor="name" className="block text-xs mt-4 font-medium leading-6 text-gray-900">
                                            Event name
                                        </label>
                                        <div className="mt-2">
                                            <input
                                            type="name"
                                            name="name"
                                            id="name"
                                            value={eventName}            
                                            onChange={(e) => { setEventName(e.target.value); }}            
                                            className="block w-full rounded-md border-0 py-1.5 px-2 text-gray-900 shadow-sm ring-1 focus-visible:outline-none ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                                            placeholder=""
                                            />
                                        </div>
                                    </div>

                                    <div>
                                        <label htmlFor="name" className="block text-xs mt-4 font-medium leading-6 text-gray-900">
                                            Event Description
                                        </label>
                                        <div className="mt-2">
                                            <textarea rows="4" cols="50"
                                            type="textarea"
                                            name="name"
                                            id="name"
                                            value={eventDescription}            
                                            onChange={(e) => { setEventDescription(e.target.value); }}            
                                            className="block w-full rounded-md border-0 py-1.5 px-2 text-gray-900 shadow-sm ring-1 focus-visible:outline-none ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                                            placeholder=""
                                            ></textarea>
                                        </div>
                                    </div>     
                                            
                                    <div className="mt-4">
                                        <Switch.Group as="div" className="flex items-center">
                                            <Switch
                                                checked={enabled}
                                                onChange={setEnabled}
                                                className={classNames(
                                                enabled ? 'bg-[var(--brand-primary)]' : 'bg-gray-200',
                                                'relative inline-flex border-[3px] h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2'
                                                )}
                                            >
                                                <span
                                                aria-hidden="true"
                                                className={classNames(
                                                    enabled ? 'translate-x-5' : 'translate-x-0',
                                                    'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out'
                                                )}
                                                />
                                            </Switch>
                                            <Switch.Label as="span" className="ml-3 text-sm">
                                                <span className="font-medium text-gray-900">On / Off</span>{' '}
                                            </Switch.Label>
                                        </Switch.Group>
                                    </div>
                                </div>
                            </div>
                            <div className="flex text-right mt-4">
                                <button
                                    type="button"
                                    className="mt-0 w-1/2 rounded-md bg-[#ffffff] border border-solid border-[var(--brand-primary)] px-3 py-2 text-sm font-semibold text-[var(--brand-primary)] shadow focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--brand-primary)]"
                                    onClick={() => {
                                        setOpenEvent(false);
                                    }}
                                >
                                    Cancel
                                </button>              
                                <button
                                    type="button"
                                    className="mt-0 ml-2 w-1/2 rounded-md bg-[var(--brand-primary)] px-3 py-2 text-sm font-semibold text-white shadow hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--brand-primary)]"
                                    onClick={() => {
                                        handleCreateEvent();    
                                    }}
                                >
                                    {mode === "new" ? "Create":"Update"}
                                </button>
                            </div>     
                        </Dialog.Panel>
                        </Transition.Child>
                    </div>
                    </div>
                </Dialog>
            </Transition.Root>
        </>
    );
};

export default SettingCalender;
